export default {
  SaleInvoice: 1,
  SaleInvoiceReplace: 2,
  SaleInvoiceAdjustment: 3,
  SaleInvoiceCancel: 4,
};
